import './style.css';

export default () => {
  const element = document.createElement('input');
  element.classList.add('input');

  return element;
};
